import React from 'react';
import style from './style.module.less';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

export const ZeroRecordsRow = () => {
  return (
    <div className={style['body-row']}>
      <div className={classnames(style['body-cell'], style['zero-state'])}>
        <FormattedMessage
          defaultMessage='There are no orders remaining in this batch.'
          description='zeroRecordsRow.noRecords'
          id='voMtmD'
        />
      </div>
    </div>
  );
};
